import {createAction, props} from '@ngrx/store';
import Order from 'src/app/models/Order';
import {OrderPool} from 'src/app/models/OrderPool';

export class LoadDigitalBoardData {
	static readonly type = '[Digital Board] Load Data';
	constructor(public payload: {venueId: string}) {}
}

export class LoadDigitalBoardDataSuccess {
	static readonly type = '[Digital Board] Load Data Success';
	constructor(
		public payload: {
			inPreparationOrders: (Order | OrderPool)[];
			readyOrders: (Order | OrderPool)[];
		}
	) {}
}

export class LoadDigitalBoardDataFailure {
	static readonly type = '[Digital Board] Load Data Failure';
	constructor(public payload: {error: string}) {}
}

export class UpdateBoardOrder {
	static readonly type = '[Digital Board] Update Order';
	constructor(public payload: {order: Order}) {}
}

export class UpdateBoardOrderPool {
	static readonly type = '[Digital Board] Update Order Pool';
	constructor(public payload: {orderPool: OrderPool}) {}
}

// NgRx actions created with createAction for effects
export const loadDigitalBoardData = createAction(
	'[Digital Board] Load Data',
	props<{venueId: string}>()
);

export const loadDigitalBoardDataSuccess = createAction(
	'[Digital Board] Load Data Success',
	props<{
		inPreparationOrders: (Order | OrderPool)[];
		readyOrders: (Order | OrderPool)[];
	}>()
);

export const loadDigitalBoardDataFailure = createAction(
	'[Digital Board] Load Data Failure',
	props<{error: string}>()
);

export const updateBoardOrder = createAction(
	'[Digital Board] Update Order',
	props<{order: Order}>()
);

export const updateBoardOrderPool = createAction(
	'[Digital Board] Update Order Pool',
	props<{orderPool: OrderPool}>()
);
